import { useEffect, useState } from "react";
import {
  Box,
  Textarea,
  Input,
  Button,
  Select,
  Stack,
  Flex,
  Text,
  Grid,
  GridItem,
  FormControl,
  FormLabel,
  useToast,
  useDisclosure,
} from "@chakra-ui/react";
import Notification from "../../services/Notification";
import { useNavigate } from "react-router-dom";
import ImageUploadModal from "../Modals/ImageUploadModal";
import TestModal from "../Modals/TestModal";

const WhatsappTemplate = ({
  setId,
  pageId,
  userId,
  notificationId,
  setNotificationId,
  emailVariables,
  whatsappVariables,
  setWhatsappVariables,
  whatsappImageUrl,
  setWhatsappImageUrl,
}: any) => {
  const token = localStorage.getItem("logged_in_user_token");
  // const [data, setData] = useState([]);
  const toast = useToast();
  const navigate = useNavigate();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [modal, setModal] = useState("");

  const [whatsapp, setWhatsapp] = useState<any[]>([]);
  const [selectedWhatsapp, setSelectedWhatsapp] = useState<any>(null);
  const [phoneNumber, setPhoneNumber] = useState("");

  const [variableCount, setVariableCount] = useState(0);

  const [selectedKeys, setSelectedKeys] = useState(
    Array(variableCount).fill("")
  );

  const [selectedValues, setSelectedValues] = useState(
    Array(variableCount).fill("")
  );

  // const [whatsappVariables, setWhatsappVariables] = useState<any>([]);

  // const [whatsappImageUrl, setWhatsappImageUrl] = useState("");

  const fetchData = async () => {
    await Notification.getWhatsappTemplates()
      .then((res) => {
        // setData(res.data);
        setWhatsapp(res.data);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          toast({
            position: "top",
            title: "Authentication Failed.",
            description: "Your session is expired.",
            status: "error",
            duration: 500,
            isClosable: true,
          });
          setTimeout(() => {
            navigate("/login");
          }, 2000);
        }
        console.log(error);
      });
  };

  const handleKeyChange = (index: number, value: string) => {
    const newKeys = [...selectedKeys];
    newKeys[index] = value;
    setSelectedKeys(newKeys);
  };

  const handleValueChange = (index: number, value: string) => {
    const newValues = [...selectedValues];
    newValues[index] = value;
    setSelectedValues(newValues);
  };

  const countVariables = (body: any) => {
    const matches = body.match(/\{\{\d+\}\}/g);
    return matches ? matches.length : 0;
  };

  const handleWhatsappChange = (event: any) => {
    const whatsappName = event.target.value;
    const selectedItem = whatsapp.find(
      (item: any) => item.name === whatsappName
    );

    setVariableCount(countVariables(selectedItem.body));
    setSelectedWhatsapp(selectedItem || null);
    setId(selectedItem?.name);
    setNotificationId(selectedItem?.name);
  };

  const handleSend = async () => {
    await Notification.updateWhatsappTemplate(
      notificationId,
      whatsappImageUrl,
      whatsappVariables
    ).then((res) => {});

    await Notification.sendDolphinActionNotification(
      "whatsapp",
      notificationId,
      userId
      // "",
      // whatsappVariables,
      // whatsappImageUrl
    ).then((res) => {
      toast({
        position: "top",
        title: "Whatsapp Message Sent.",
        description: "Whatsapp Message is sent to the user successfully.",
        status: "success",
        duration: 1000,
        isClosable: true,
      });
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    const updatedSelectedValues = selectedKeys.map((key) => {
      return key && emailVariables[key] !== undefined
        ? Array.isArray(emailVariables[key])
          ? emailVariables[key].join(", ")
          : emailVariables[key]
        : ""; // empty string instead of undefined
    });

    setSelectedValues(updatedSelectedValues);

    setWhatsappVariables(
      ["leads-reachout", "customer-reachout"].includes(pageId)
        ? selectedKeys
        : updatedSelectedValues
    );
  }, [selectedKeys, emailVariables, whatsappImageUrl]);

  useEffect(() => {
    setSelectedKeys(Array(variableCount).fill(""));
    setSelectedValues(Array(variableCount).fill(""));
  }, [variableCount]);

  return (
    <Box bg="gray.100" p={6}>
      <Grid templateColumns="repeat(3, 1fr)" gap={2}>
        <GridItem bg="#f6ffff" colSpan={2}>
          <Box p={3} bg="#518585" color="white">
            {selectedWhatsapp?.name}
          </Box>
          <Textarea
            h="300px"
            border="0px"
            placeholder="Dear: ..."
            defaultValue={selectedWhatsapp?.body || ""}
            p={2}
          />

          {!["leads-reachout", "customer-reachout"].includes(pageId) && (
            <Flex p={2} align="center" gap={8}>
              <Button
                colorScheme="yellow"
                size="sm"
                onClick={() => handleSend()}
              >
                SEND
              </Button>
              <Button
                colorScheme="yellow"
                size="sm"
                onClick={() => {
                  setModal("testModal");
                  onOpen();
                }}
              >
                SEND TO TEST USER
              </Button>
              {modal === "testModal" && (
                <TestModal
                  isOpen={isOpen}
                  onClose={onClose}
                  templateId={notificationId}
                  whatsappVariables={whatsappVariables}
                  whatsappImageUrl={whatsappImageUrl}
                  type="whatsapp"
                />
              )}
            </Flex>
          )}
        </GridItem>

        <GridItem p={6} gap={2}>
          <Stack spacing={8}>
            <FormControl>
              <FormLabel fontSize="lg" fontWeight="semibold">
                Choose Template
              </FormLabel>
              <Select
                placeholder="Select"
                value={selectedWhatsapp?.template_name}
                onChange={handleWhatsappChange}
              >
                {whatsapp.map((item: any, index: any) => (
                  <option key={index} value={item.name}>
                    {item.name}
                  </option>
                ))}
              </Select>
            </FormControl>
            <FormControl>
              <FormLabel fontSize="lg" fontWeight="semibold">
                Choose Image
              </FormLabel>
              <Flex direction="column" gap={4}>
                <Flex justifyContent="center" alignItems="center" gap="4">
                  <Select
                    placeholder="Select"
                    onChange={(e) => {
                      if (e.target.value === "image") {
                        setModal("imageUpload");
                        onOpen();
                      }
                    }}
                  >
                    <option value="image">Image</option>
                  </Select>
                  {modal === "imageUpload" && (
                    <ImageUploadModal
                      isOpen={isOpen}
                      onClose={onClose}
                      setImageValue={setWhatsappImageUrl}
                    />
                  )}

                  <Input
                    type="text"
                    paddingLeft={2}
                    bg="white"
                    id="image"
                    name="image"
                    placeholder=""
                    value={whatsappImageUrl || "Not Known"}
                    disabled={true}
                  />
                </Flex>
              </Flex>
            </FormControl>
            {variableCount && (
              <FormControl>
                <FormLabel fontSize="lg" fontWeight="semibold">
                  Choose Variables
                </FormLabel>
                <Flex direction="column" gap={4}>
                  {Array.from({ length: variableCount }).map((_, index) => (
                    <Flex
                      key={index}
                      justifyContent="center"
                      alignItems="center"
                      gap="4"
                    >
                      <Text fontWeight="medium" fontSize="20px">
                        [{index + 1}]
                      </Text>
                      <Select
                        placeholder="Select"
                        value={selectedKeys[index]}
                        onChange={(e) => {
                          handleKeyChange(index, e.target.value);
                        }}
                      >
                        {Object.keys(emailVariables).map((item) => (
                          <option key={item} value={item}>
                            {item}
                          </option>
                        ))}
                        {/* {<option value="image">Image</option>} */}
                        {/* <option value="link">Link</option> */}
                      </Select>

                      {!["leads-reachout", "customer-reachout"].includes(
                        pageId
                      ) && (
                        <Input
                          onChange={(e) => {
                            handleValueChange(index, e.target.value);
                          }}
                          type="text"
                          paddingLeft={2}
                          bg="white"
                          id="variable"
                          name="variable"
                          placeholder=""
                          value={
                            Array.isArray(selectedValues[index]) &&
                            selectedValues[index].every((val: any) => !val)
                              ? "Not Known"
                              : selectedValues[index] || "Not Known"
                          }
                          disabled={true}
                        />
                      )}
                    </Flex>
                  ))}
                </Flex>
              </FormControl>
            )}
          </Stack>
        </GridItem>
      </Grid>
    </Box>
  );
};

export default WhatsappTemplate;
